// ===================
// Web Portfolio Backbone App
// ===================
var PortfolioApp = new(Backbone.View.extend({
	// MVC containers
	Models: {},
	Views: {},
	Collections: {},
	Defaults: PortfolioAppDefaults, // built externally in defaults.js
	Values: {},
	Elements: {},
	initStatic: function() {
		// Sigh, rendering is tricky
		this.setRenderingMath();

		// Entries setup (collection and views)
		var entries = new this.Collections.Entries();
		var entriesView = new this.Views.Entries({
			collection: entries
		});
		entriesView.render();
		entries.fetch({
			reset: true
		});
		// now it's globally available
		this.Values.Entries = entries;
		this.Values.EntriesView = entriesView;
		jQuery('#portfolio-entries').html(entriesView.el);

		// Categories setup
		var categoriesView = new this.Views.Categories({
			collection: this.Defaults.Categories
		});
		categoriesView.render();
		// now it's globally available
		this.Values.Categories = this.Defaults.Categories; // Categories used in the app
		jQuery('#categoery-selector-list').html(categoriesView.el);
	},
	init: function() {
		// Elements
		this.Elements.Title = jQuery("#add-title");
		this.Elements.Subtitle = jQuery("#add-subtitle");
		this.Elements.Description = jQuery("#add-description");
		this.Elements.Image = jQuery("#add-image");
		this.Elements.Link = jQuery("#add-link");

		// Entries setup (collection and views)
		var entries = new this.Collections.EntriesLocal();
		entries.fetch();
		if (entries.models.length < 1) {
			console.log('create!');
			entries.create({}); // add a starter!
		}

		this.Values.Entries = entries;

		// Entries view
		var entriesView = new this.Views.Entries({
			collection: entries
		});
		entriesView.render();
		this.Values.EntriesView = entriesView;
		jQuery('#portfolio-entries').html(entriesView.el);

		// Listeners
		this.listenTo(this.Values.Entries, 'add', this.addOne);
	},
	events: {
		"click #add-entry": "addEntry"
	},
	addOne: function(entry) {
		var view = new PortfolioApp.Views.Entry({
			model: entry
		});
		this.Values.EntriesView.showEntry(entry);
	},
	addEntry: function(e) {
		e.preventDefault();
		PortfolioApp.Values.Entries.create({
			title: this.Elements.Title.val(),
			subtitle: this.Elements.Subtitle.val(),
			description: this.Elements.Description.val(),
			img: this.Elements.Image.val(),
			link: this.Elements.Link.val()
		});
		this.clearForm();
	},
	clearForm: function() {
		this.Elements.Title.val('');
		this.Elements.Subtitle.val('');
		this.Elements.Description.val('');
		this.Elements.Image.val('');
		this.Elements.Link.val('');
	},
	setRenderingMath: function() {
		this.Values.offsetHeight = document.getElementById('header_across').offsetHeight + document.getElementById('category-selector').offsetHeight;
		this.Values.header_across = jQuery("#header_across");
		this.Values.main_content = jQuery("#mainContent");
		this.Values.stickyClass = "stuck";
		this.Values.stuckHeaderHeight = 85;
		this.Values.gutter = 20;
		this.Values.stickyHeight = header_across.height() - stuckHeaderHeight;
		this.Values.hrHeight = gutter + 2;
		this.Values.isXS = false;
		if (jQuery(window).width() < 768) {
			this.Values.isXS = true;
		}

		jQuery(window).scroll(function() {
			if (jQuery(window).width() < 768) {
				if (jQuery(this).scrollTop() > stickyHeight) {
					main_content.css({
						"margin-top": PortfolioApp.Values.offsetHeight + PortfolioApp.Values.gutter * 3
					});
				} else {
					main_content.css({
						"margin-top": 0
					});
				}
			}
		});
	}
}))({
	el: jQuery('#portfolio-app')
});
